<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      downKey: 0,
      mainTitle: "지피테라퓨틱스",
    };
  },
  metaInfo() {
    return {
      title: this.mainTitle,
    };
  },
  created() {
    // 최근 build / build 날짜 확인
    // const code = process.env.VUE_APP_VERSION_CODE;
    // const release_date = process.env.VUE_APP_RELEASE_DATE;
    // const isDev = process.env.NODE_ENV;
    // console.log("code / release_date", code, release_date, isDev);

    this.initLocale();
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    mq.addEventListener("change", (e) => {
      this.$vuetify.theme.dark = e.matches;
    });
    // this.getRouterParams();
  },
  methods: {
    initLocale() {
      let locale = "en";
    },
    getRouterParams() {
      // console.log(this.$router.currentRoute.query);
    },
    windowCloseHandler() {
      // console.log("windowClose", this.downKey);
    },
  },
  // key test
  mounted() {
    document.onkeydown = function (e) {
      this.downKey = e.keyCode;
      /* F5, Ctrl+r, Ctrl+F5 */
      if (e.keyCode == 116 || (e.ctrlKey == true && e.keyCode == 82)) {
        e.cancelBubble = true;
        e.returnValue = false;
        return false;
      }
    };
    // window 닫을때 처리
    window.addEventListener("beforeunload", this.windowCloseHandler, false);

  },
};
</script>
